<template lang="pug">
  .layout-service.bg-alt
    side-nav(:content="menuItems", :access="account.user.type")
    .content.pb-5
      transition(name="page", mode="out-in")
        router-view
</template>

<script>
import SideNav from '@/components/structure/SideNav';
import { mapState } from 'vuex';

export default {
  name: 'LayoutService',
  components: {
    SideNav,
  },
  data() {
    return {
      menuItems: {
        title: 'Artist Panel',
        items: [
          {
            label: 'DASHBOARD',
            route: 'Dashboard',
            noMobile: false,
          },
          {
            label: 'ART',
            route: 'Art',
            noMobile: false,
          },
          {
            label: 'ORDERS',
            route: 'Orders',
            noMobile: true,
          },
          {
            label: 'RENTALS',
            route: 'RentalsLive',
            noMobile: true,
          },
          {
            label: 'PAYOUTS',
            route: 'PayoutsHistory',
            noMobile: true,
          },
          {
            label: 'ACCOUNT',
            route: 'AccountProfile',
            mobile: false,
          },
        ],
      },
    };
  },
  methods: {
  },
  computed: {
    ...mapState('account', ['account']),
  },
};
</script>

<style lang="scss" scoped>
  .layout-service {
    // display: flex;
    position: relative;
    min-height: 100vh;
  // Router transition
  }
  .page-enter-active, .page-leave-active {
    transition: transform 0.2s;
  }
  .page-enter {
    transform: translateX(100%);
  }
  .page-leave-to {
    transform: translateX(100%);
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutService.vue